export default __webpack_public_path__ + "47b6e37.png";